// src/components/HizmetlerPreview.js
import React from 'react';
import { Link } from 'react-router-dom';
import './HizmetlerPreview.css';

const hizmetOzet = [
  { ikon: "🛠️", baslik: "Servis & Bakım" },
  { ikon: "🔄", baslik: "Genel Revizyon" },
  { ikon: "📈", baslik: "Enerji Analizi" },
  { ikon: "📏", baslik: "Debi Ölçüm" },
  { ikon: "⚙️", baslik: "Yedek Parça" },
  { ikon: "🚛", baslik: "Satış & Kiralama" },
];

const HizmetlerPreview = () => {
  return (
    <section className="hizmetler-preview">
      <h2>🛠️ Hizmetlerimiz</h2>
      <div className="hizmet-kart-grid">
        {hizmetOzet.map((h, i) => (
          <div key={i} className="hizmet-mini-kart">
            <div className="hizmet-ikon">{h.ikon}</div>
            <div className="hizmet-baslik">{h.baslik}</div>
          </div>
        ))}
      </div>
      <div className="hizmet-link">
        <Link to="/hizmetler" className="detay-buton">➕ Tüm Hizmetleri Gör</Link>
      </div>
    </section>
  );
};

export default HizmetlerPreview;
